import { useEffect, useState } from 'react'
import { getOrders } from '../../services/api/orders'
import DefaultLoader from '../Loaders/DefaultLoader'
import OrderItem from '../OrderItem/OrderItem'
import { useNavigate } from 'react-router-dom'
import Button from '../Button/Button'
import { GetOrders200Response, Order, OrderPhase } from '../../model'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface IOrdersWidget {
    limit?: number
}
const OrdersWidget = ({ limit }: IOrdersWidget) => {
    const [loading, setLoading] = useState(false)
    const [orders, setOrders] = useState<Order[]>([])
    const navigate = useNavigate()

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true)
            try {
                let params: any = {
                    phase: [OrderPhase.Active, OrderPhase.Completed],
                    page: 1,
                    pageSize: limit || 4
                }
                const res: GetOrders200Response = await getOrders(params)
                setOrders(res?.items || [])
            } catch (e) {
                console.error(e)
            }
            setLoading(false)
        }
        fetchOrders()
    }, [limit])

    return (
        <div className='bg-white shadow-sm border-full rounded-xl h-auto'>
            {/* CONTENT */}
            <div className='flex flex-col'>
                {/* LOADER */}
                {loading ? (
                    <div className='w-full flex justify-center pt-8 pb-4'>
                        <DefaultLoader />
                    </div>
                ) : orders.length === 0 ? (
                    <div className='text-center text-gray-400 py-8'>Geen opdrachten</div>
                ) : (
                    orders.map((order: Order) => {
                        return <OrderItem showPhase key={order.id} data={order} />
                    })
                )}
            </div>
            {orders.length > 0 && (
                <div className='px-4 py-4'>
                    <Button buttonStyle='white' onClick={() => navigate('orders')}>
                        Alle opdrachten
                        <DynamicFaIcon iconName='arrow-right' className='ml-2' />
                    </Button>
                </div>
            )}
        </div>
    )
}

export default OrdersWidget
